/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";
import "./style.css";

export const SwapDummy = ({ className, overlapGroupClassName, dummyClassName }) => {
  return (
    <div className={`swap-dummy ${className}`}>
      <div className={`dummy-wrapper ${overlapGroupClassName}`}>
        <div className={`text-wrapper ${dummyClassName}`}>D</div>
      </div>
    </div>
  );
};
